import style from './Logo.module.scss';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const FooterLogo = ({ className, ...restProps }: Props) => {
  return (
    <a href="/" className={`${style.footerLogo} ${className}`} {...restProps}>
      <h1>IURI.GE</h1>
    </a>
  );
};

export default FooterLogo;
